module.exports = __webpack_public_path__ + "media/assets/icons/chevron-small-down-6e4af6641b5c2b5bf8b5c25bc6308a30.svg";